module.exports = __webpack_public_path__ + "img/4-2.27e8f01b.svg";